import { Chart } from 'chart.js/auto'
import React, { ComponentPropsWithRef, useContext, useEffect } from 'react'
import { twMerge } from 'tailwind-merge'
import { Assignation } from '../context/types'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import { info } from '../services/sentryLogger'


interface Props extends ComponentPropsWithRef<'div'> {
    assignations: Assignation[],
    nBuckets: number,
}
export const MyChart = (p: Props) => {
    const { className, assignations, nBuckets, ...rest } = p
    const ref = React.useRef<HTMLCanvasElement>(null)
    const t = useTranslation(useCommonCtx());


    useEffect(() => {
        info('MyChart mount', ref.current);
        let myChart: Chart|null = null;
        info('MyChart data', nBuckets, assignations);
        let data : any[] = new Array(nBuckets);

        if (ref.current && assignations.length && nBuckets) {
            assignations.forEach(({ bucket }, i) => {
                info('MyChart forEach', {data, bucket, i});
                if(bucket !== undefined) data[bucket] = {
                    ...data[bucket],
                    bucket,
                    count: (data[bucket]?.count ?? 0) + 1,
                }
            });
            data = data.filter((row) => row !== undefined); // FIXME
            info('MyChart data', nBuckets, assignations, data);
            myChart = new Chart(ref.current, {
                type: 'bar',
                options: {
                    responsive: true,
                },
                data: {
                    labels: data.map((row) => `${t('bucket')} ${row.bucket}`),
                    datasets: [
                        {
                            label: t('axis_y'),
                            data: data.map((row) => row.count),
                        },
                    ],
                },
            })
        }

        return () => {
            info('MyChart unmount');
            myChart?.destroy();
        }
    }, [ref.current, assignations.length, nBuckets])

    return (
        <div className={twMerge(' w-48', className)} {...rest}>
            <canvas ref={ref} />
        </div>
    )
}
